import Vue from 'vue'
import VueRouter from 'vue-router'
import OidcCallback from '../views/OidcCallback.vue'
import OidcCallbackError from '../views/OidcCallbackError.vue'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store'

import DeparturesAndArrivals from '@/views/DeparturesAndArrivals'
import FlightsSearch from '@/views/FlightsSearch'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/events/all',
    meta: {
      roles: ['user']
    }
  },
  {
    path: '/events',
    redirect: '/events/all',
    meta: {
      roles: ['user']
    }
  },
  {
    path: '/events/:mode',
    name: 'events',
    component: DeparturesAndArrivals,
    meta: {
      roles: ['user']
    }
  },
  {
    path: '/flights/search',
    component: FlightsSearch,
    meta: {
      roles: ['user']
    }
  },
  {
    path: '/login/oauth2/code/adfs', // Needs to match redirectUri in you oidcSettings
    name: 'oidcCallback',
    component: OidcCallback
  },
  {
    path: '/signin-oidc-error', // Needs to match redirect_uri in you oidcSettings
    name: 'oidcCallbackError',
    component: OidcCallbackError,
    meta: {
      isPublic: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))

export default router
